var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dialog-container" },
    [
      _c(
        "yd-dialog",
        {
          attrs: {
            title: _vm.title + "操作日志",
            visible: _vm.visible,
            width: "60%",
            "append-to-body": "",
            "before-close": _vm.handleClose,
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-content" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    inline: true,
                    model: _vm.form,
                    "label-width": "80px",
                    size: "mini",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "操作时间" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "datetimerange",
                          "range-separator": "至",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          value: "yyyy-MM-dd HH:mm:ss",
                          editable: false,
                          clearable: false,
                          "picker-options": _vm.pickerOptions,
                        },
                        on: { change: _vm.handleDateChange },
                        model: {
                          value: _vm.form.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "date", $$v)
                          },
                          expression: "form.date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "操作人" } },
                    [
                      _c("yd-common-selector", {
                        attrs: { options: _vm.opratorUser },
                        model: {
                          value: _vm.form.unionUserId,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "unionUserId", $$v)
                          },
                          expression: "form.unionUserId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "操作类型" } },
                    [
                      _c("yd-common-selector", {
                        attrs: {
                          options: _vm.flightPlanList,
                          multiple: _vm.operateTypeIsMultiple,
                        },
                        model: {
                          value: _vm.form.operateType,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "operateType", $$v)
                          },
                          expression: "form.operateType",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini", type: "primary" },
                          on: { click: _vm.getLogs },
                        },
                        [_vm._v("查询")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.handleClear },
                        },
                        [_vm._v("清空")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("avue-crud", {
                ref: "crud",
                attrs: {
                  height: "max-height: 67vh",
                  "table-loading": _vm.loading,
                  option: _vm.option,
                  data: _vm.logList,
                  page: _vm.page,
                },
                on: {
                  "update:page": function ($event) {
                    _vm.page = $event
                  },
                  "current-change": _vm.currentChange,
                  "size-change": _vm.sizeChange,
                  "refresh-change": _vm.refreshChange,
                },
                scopedSlots: _vm._u([
                  {
                    key: "newRecord",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm.active === 1
                          ? _c("div", [
                              _vm._v(
                                _vm._s(
                                  "城际订单号：" +
                                    row.orderNo +
                                    " " +
                                    row.newRecord
                                )
                              ),
                            ])
                          : _vm.active === 2
                          ? _c("div", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    "同城订单号：" +
                                      row.orderNo +
                                      " " +
                                      row.newRecord
                                  ) +
                                  "\n          "
                              ),
                            ])
                          : _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  "popper-class": "log-tool-tip",
                                  effect: "dark",
                                  placement: "top",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "content",
                                      fn: function () {
                                        return [
                                          _c("p", [
                                            _vm._v(_vm._s(row.newRecord)),
                                          ]),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "100",
                                      "white-space": "nowrap",
                                      overflow: "hidden",
                                      "text-overflow": "ellipsis",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(row.newRecord) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                  {
                    key: "oldRecord",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              effect: "dark",
                              content: row.oldRecord,
                              placement: "top-start",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100",
                                  "white-space": "nowrap",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(row.oldRecord) +
                                    "\n            "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "operatorName",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        row.operatorUserIdType === 2
                          ? _c("yd-link", {
                              key: row.uuid,
                              attrs: {
                                value: row.operatorName,
                                type: "systemUser",
                                query: { userId: row.unionUserId },
                              },
                            })
                          : _c("span", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(row.operatorName) +
                                  "\n          "
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "text",
                    fn: function (ref) {
                      var row = ref.row
                      return _vm._l(row.textList, function (item) {
                        return _c(
                          "div",
                          { key: item, staticStyle: { width: "100%" } },
                          [_vm._v(_vm._s(item))]
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.handleClose } },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }